<template>
    <Card style="height: 100%;overflow:auto">
        <template #title>
            <div style="padding: 5px 0;display:flex;justify-content: space-between;">
              <div style="margin: auto 0;">菜单管理</div>
              <div><Button type="primary" v-if="buttonMenu['/menu/add']" @click="handleShowModal()">添加</Button></div>
            </div>
        </template>
        <Layout  style="height:100%;overflow-y:auto;overflow-x:hidden;background:#fff;">
            <Sider :width="400" style="height: 600px;">
                <Tree style="font-size:14px;" :render="renderContent" :data="data" @on-select-change="handleSelectTreeNode"></Tree>
            </Sider>
            <Content style="height:100%;position:sticky;top:0;margin-right: 10px;">
                <div v-if="buttonMenu['/menu/view']">
                  <div style="margin: 5px 0 10px;display:flex;justify-content: space-between;">
                    <div></div>
                    <div><Button type="primary" v-if="buttonMenu['/menu/permission/add']" @click="handleAddPermission()">添加权限</Button></div>
                </div>
                <Table :columns="[...columns,{title:'操作',slot:'action'}]" :data="tableData" :height="500" :loading="tableLoading1">
                    <template #action="{row}">
                        <Poptip confirm title="确定要删除吗？" v-if="buttonMenu['/menu/permission/delete']" transfer @on-ok="handleDel(row)"><a style="margin-left: 10px;color: red">删除</a></Poptip>
                    </template>
                </Table>
                </div>
            </Content>
        </Layout>

        <Modal v-model="visible" :title="form.id?'编辑':'新增'+'菜单'" >
            <Form @submit.native.prevent v-if="visible" :label-width="100" :model="form" ref="formRef">
                <FormItem label="菜单名称" prop="menuName" :rules="[{required:true,message:'请输入菜单名称'}]">
                    <Input v-model="form.menuName" />
                </FormItem>
                <FormItem label="菜单地址" prop="menuPath" :rules="[{required:true,message:'请输入菜单地址'}]">
                    <Input v-model="form.menuPath" />
                </FormItem>
            </Form>

            <template #footer>
                <Button @click="visible=false">取消</Button>
                <Button type="primary" @click="handleSubmit" :loading="loading">提交</Button>
            </template>
        </Modal>
        <Modal v-model="permissionVisible" title="添加权限" :width="800">
            <div class="search-form">
                <Input :maxlength="100" v-model="searchForm.permissionName" placeholder="请输入权限名称" />
                <Input :maxlength="100" v-model="searchForm.permissionPath" placeholder="请输入权限路径" />
                <Button type="primary" @click="getTableDataNotIn()">查询</Button>
                <Button @click="searchForm={}">重置</Button>
            </div>
            <Table :loading="tableLoading" :columns="[{type:'selection'},...columns]" :data="tableDataNotIn" :height="500" @on-select="handleSelect" @on-select-all="selectedTableData=[...selectedTableData,...$event]">
                <Pages slot="footer" :page="page" :func="getTableDataNotIn"></Pages>
            </Table>
            <template #footer>
                <Button @click="permissionVisible=false;selectedTableData=[]">取消</Button>
                <Button @click="handleSubmitPermission()" type="primary" :loading="submitLoading">提交</Button>
            </template>
        </Modal>
    </Card>
</template>

<script>
import Pages from '@/components/pages'
import {
  getPermissionListNotIn,
  getMenuTree,
  addMenuPermission,
  delMenuPermission,
  getMenu,
  addMenu,
  editMenu,
  delMenu,
  getPermissionList } from '@/api/menu'
export default {

  components:{ Pages },
  data() {
    return {
      data:[],
      tableData: [],
      tableDataNotIn: [],
      selectedTableData:[],
      columns: [
        {
          key: 'id',
          title: '权限id'
        },
        {
          key: 'permissionName',
          title: '权限名称'
        },
        {
          key: 'permissionPath',
          title: '权限路径'
        }

      ],
      selectNode:{},
      page:{
        current:1,
        size: 10,
        total: 0
      },
      form: {},
      searchForm: {},
      visible: false,
      permissionVisible: false,
      submitLoading:false,
      tableLoading:false,
      tableLoading1:false,
      loading:false
    }
  },
  computed:{
    buttonMenu() {
      const li = this.$store.getters.getMenuRules('system/menu')
      const obj = {}
      li.forEach(i => {
        obj[i.menuPath] = true
      })
      return obj
    }
  },
  methods:{
    recursion(data) {
      return data.map(el => {
        // el.expand = true
        if (el.id === this.selectNode.id) {
          el.selected = true
        }
        if (el.children && el.children.length) {
          el.children = this.recursion(el.children)
        }
        return el
      })
    },
    getData(options) {
      getMenuTree().then(r => {
        if (!options) {
          this.data = this.recursion(r.data)
          console.log(this.data)
        }
      })
    },
    getTableData(id) {
      if (!id) this.tableData = []
      this.tableLoading1 = true
      getPermissionList(id).then(r => {
        this.tableData = r.data
        this.tableLoading1 = false
      })
    },
    getTableDataNotIn(page) {
      if (page) this.page.current = page
      else this.page.current = 1
      this.tableLoading = true
      getPermissionListNotIn({ id:this.selectNode.id, ...this.page, ...this.searchForm }).then(r => {
        const selecteds = this.selectedTableData.map(i => i.id)
        this.tableDataNotIn = r.data.records.map(i => ({
          ...i,
          _checked:selecteds.includes(i.id)
        }))
        this.tableLoading = false
        this.page.total = r.data.total
      })
    },
    handleAddPermission() {
      if (!this.selectNode.id) {
        this.$Message.error('请选择菜单节点')
        return
      }
      this.searchForm = {}
      this.selectedTableData = []
      this.getTableDataNotIn()
      this.permissionVisible = true
    },
    handleSubmitPermission() {
      let obj = {}
      const params = this.selectedTableData.filter(i => {
        if (!obj[i.id]) {
          obj[i.id] = true
          return true
        }
      }
      ).map(el => ({
        menuId:this.selectNode.id,
        permissionId: el.id
      }))
      if (!params.length) { this.permissionVisible = false; return }
      this.submitLoading = true

      addMenuPermission([...params]).then(r => {
        this.$Message.success('操作成功')
        this.getTableData(this.selectNode.id)
        this.selectedTableData = []
        this.permissionVisible = false
        this.submitLoading = false
      }).catch(e => {
        this.permissionVisible = false
        this.submitLoading = false
      })
      obj = null
    },
    handleDel(row) {
      delMenuPermission([row.menuPermissionId]).then(r => {
        this.$Message.success('操作成功')
        this.getTableData(this.selectNode.id)
      })
    },
    handleSubmit() {
      this.$refs.formRef.validate(r => {
        if (r) {
          this.loading = true
          const func = this.form.id ? editMenu : addMenu
          func({
            ...this.form,
            parentId: this.form.id ? this.form.parentId : this.selectNode.id
          }).then(r => {
            this.$Message.success('操作成功')
            this.loading = false
            this.visible = false
            this.getData()
          }).catch(e => {
            this.loading = false
            this.visible = false
          })
        }
      })
    },
    async handleShowModal(data) {
      this.form = {
        parentId:this.selectNode.id || 0
      }
      if (data) {
        const r = await getMenu(data.id)
        this.form = r.data
      }
      this.visible = true
    },
    handleSelectTreeNode(arr) {
      const data = arr[0] || {}

      this.selectNode = { ...data }
      if (data.id) {
        this.getTableData(data.id)
      }
    },
    handleSelect(data) {
      this.selectedTableData = [...this.selectedTableData, ...data]
    },
    renderContent(h, { root, node, data }) {
      return <span style="display:inline-block;width:100%">
        <span>
          <Icon type={'ios-paper-outline'} style="margin-right:8px"></Icon>
          <span>{data.menuName}</span>
          <span style="display:inline-block;float:right;margin-right:32px;">
            {this.buttonMenu['/menu/edit'] ? <a style="margin-right:8px;" onClick={(e) => {
              e.stopPropagation()
              this.handleShowModal(data)
            }}>编辑</a> : ''}
            {this.buttonMenu['/menu/delete'] ? <a style="margin-right:8px;color:red" onClick={(e) => {
              e.stopPropagation()
              if(data.children&&data.children.length){
                this.$Message.error('请先删除子菜单')
                return
              }
              this.$Modal.confirm({
                title:'确定要删除吗？',
                onOk:() => {
                  delMenu(data.id).then(r => {
                    this.getData()
                  })
                }
              })
            }}>删除</a> : ''}
          </span>
        </span>
      </span>
    }
  },
  mounted() {
    this.getData()
  }
}
</script>

<style lang="less" scoped>
/deep/.ivu-layout-sider{
    background-color: #fff;
}
/deep/.ivu-card-body{
    overflow: auto;
    padding-bottom: 20px;
}

/deep/.ivu-card-head{
  position: sticky;
  top: 0;
  z-index: 99;
  padding: 7px 16px;
  background-color: #fff;
}
/deep/.ivu-card-extra{
  position: sticky;
  top: 14px;
  right: 16px;
  float: right;
  z-index: 2;
  background-color: #fff;
}
/deep/.ivu-tree-title{
        width: 95%;
    }

/deep/.ivu-tree ul{
    font-size: 14px;
}
.search-form{
    display:flex;
    &>*{
        margin: 0 5px;
    }
    margin-bottom: 10px;
}
.ivu-layout::-webkit-scrollbar{
  background-color: #eee;
  width: 4px;
}
.ivu-layout::-webkit-scrollbar-thumb{
  background-color: #999;
  border-radius: 50px;
}
</style>
